<div class="menubar-hoverable header-fixed menubar-pin" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #f7f9fa;
  ">
  <!-- Header -->

  <!-- Menu -->

  <!-- Main Content -->
  <div (click)="closeWingOption()" id="base">
    <div id="content" class="checkin-checkout-main-container">
      <div (click)="collapseColumnOption($event)" class="page-info-with-export-button">
        <div class="page-name-category-wise">
          <span class="report-text-category">{{ 'report' | translate }} </span>
          <span class="report-text-category-main-page">
            {{'checkinCheckout' | translate}}
          </span>
        </div>
        <div class="export-button-container-category-wise">
          <button class="btn-export-checkin-checkout" (click)="openExportReportPopUp()">
            <i class="ri-download-2-line"></i>
            {{ 'export' | translate }}
          </button>
        </div>

      </div>
      <div class="filter-container-checkin-checkout">
        <div [ngClass]="{
  'filter-info' : !isFilterOpen,
  'filter-info-open' : isFilterOpen
}">
          <div class="filter-sub-container">
            <div class="filter-container">
              <div class="filter-by-heading">{{'filteredBy' | translate}}</div>

              <div class="payee-type">
                <div class="label-checkin-checkout">{{'wingLabel' | translate}}</div>
                <div class="label-checkin-checkout-value">
                  {{ !isFilterApplied? 'All': appliedWing === 'All'? 'All': appliedWing.length === wingListData.length? 'All': appliedWing.length + ' selected'}}
                </div>
              </div>

              <div class="payee-type">
                <div class="label-checkin-checkout">{{'classLabel' | translate}}</div>
                <div class="label-checkin-checkout-value">
               {{ !isFilterApplied? 'All': appliedClass === 'All'? 'All': appliedClass.length === classStandardData.length? 'All': appliedClass.length + ' selected'}}
                </div>
              </div>

              <div class="payee-type">
                <div class="label-checkin-checkout">{{'sectionLabel' | translate}}</div>
                <div class="label-checkin-checkout-value">
                 {{ !isFilterApplied? 'All': appliedSection === 'All'? 'All': appliedSection.length === classSectionData.length? 'All': appliedSection.length + ' selected'}}
                </div>
              </div>

              <div class="payee-type">
                <div class="label-checkin-checkout">{{'dateLabel' | translate}}</div>
                <div class="label-checkin-checkout-value">{{ appliedDate }}</div>
              </div>

              <div class="payee-type">
                <div class="label-checkin-checkout">{{'entrystatusLabel'|translate}}</div>
                <div class="label-checkin-checkout-value">{{ getEntryStatusLabel(appliedEntryStatus) }}</div>
              </div>
              <div class="filter-actions"> <button class="more-filter-btn" *ngIf="isFilterApplied"
                  (click)="resetFilter()">{{ 'resetLabel' | translate }}</button>
                <button class="more-filter-btn" (click)="expandView()">
                  {{!isFilterOpen ? ('moreFilter'| translate) : ('lessFilter' | translate) }}
                </button>
              </div>

            </div>
          </div>

          <div class="selection-container-filter" >
            <!-- Wing -->
            <div class="selection-box-checkin-checkout-data">
              <div class="label-checkin-checkout-data">{{'wing' |translate}}</div>
              <div class="input-for-selection-checkin-checkout">
                <p-multiSelect [options]="loadingWingData? [] :wingListData" [(ngModel)]="selectedWings"
                  optionLabel="classCategoryName" display="comma" [maxSelectedLabels]="0"
                  [selectedItemsLabel]="customWingLabel" placeholder="All" (onChange)="onWingChange($event)"
                  appendTo="body"><ng-template pTemplate="footer">
                    <div *ngIf="loadingWingData" class="loader-inside-dropdown">
                      <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                    </div>
                  </ng-template>
                </p-multiSelect>
                <ng-container *ngIf="loadingWingData">
                  <div class="loader-dropdown">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- Class -->
            <div class="selection-box-checkin-checkout-data">
              <div class="label-checkin-checkout-data">{{'class' | translate}}</div>
              <div class="input-for-selection-checkin-checkout">
                <p-multiSelect [options]="loadingClassData? [] :classStandardData" [(ngModel)]="selectedClassList"
                  optionLabel="classStandardName" display="comma" [maxSelectedLabels]="0"
                  [selectedItemsLabel]="customClassLabel" placeholder="All" (onChange)="onClassChange($event)"
                  appendTo="body" style="width: 100%;"><ng-template pTemplate="footer">
                    <div *ngIf="loadingClassData" class="loader-inside-dropdown">
                      <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                    </div>
                  </ng-template></p-multiSelect>
                <ng-container *ngIf="loadingClassData">
                  <div class="loader-dropdown" style="margin-left: 8px;">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- Section -->
            <div class="selection-box-checkin-checkout-data">
              <div class="label-checkin-checkout-data">{{'section' | translate}}</div>
              <div class="input-for-selection-checkin-checkout">
                <p-multiSelect [options]="loadingSectionData? [] : classSectionData" [(ngModel)]="selectedSectionList"
                  optionLabel="displaySection" display="comma" [maxSelectedLabels]="0"
                  [selectedItemsLabel]="customSectionLabel" placeholder="All" (onChange)="onSectionChange($event)"
                  appendTo="body">
                  <ng-template pTemplate="footer">
                    <div *ngIf="loadingSectionData" class="loader-inside-dropdown">
                      <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                    </div>
                  </ng-template>
                </p-multiSelect>
                <ng-container *ngIf="loadingSectionData">
                  <div class="loader-dropdown" style="margin-left: 8px;">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- Student Search -->
            <div class="selection-box-checkin-checkout-data"
              *ngIf="selectedSectionList.length === 1 && selectedClassList.length === 1 && selectedWings.length === 1">
              <div class="label-checkin-checkout-data">{{'student' | translate}}</div>
              <div class="input-for-selection-checkin-checkout">
                <p-multiSelect [options]="loadingStudentData ? [] : filteredStudentList"
                  [(ngModel)]="selectedStudentList" optionLabel="studentName" optionValue="studentId" display="comma"
                  placeholder="Search and select students" [filter]="true" filterBy="studentName,studentId"
                  (onChange)="onStudentChange($event)" appendTo="body" selectedItemsLabel="{0} students selected">
                  <ng-template pTemplate="footer">
                    <div *ngIf="loadingStudentData" class="loader-inside-dropdown">
                      <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                    </div>
                  </ng-template>

                </p-multiSelect>
                <ng-container *ngIf="loadingStudentData">
                  <div class="loader-dropdown" style="margin-left: 8px;">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="selection-box-checkin-checkout-data date-picker-container">
              <div class="label-checkin-checkout-data">{{'date' | translate}}</div>
              <div class="input-for-selection-checkin-checkout">
                <p-calendar [(ngModel)]="selected" [showIcon]="true" [placeholder]="startDate"
                  dateFormat="dd/mm/yy" [minDate]="selectedAcademicYear" [maxDate]="today"
                  appendTo="body" (onSelect)="dateSelected($event)" [readonlyInput]="true" style="width: 100%;"></p-calendar>
              </div>
            </div>
            <!-- Entry Status -->
            <div class="selection-box-checkin-checkout-data">
              <div class="label-checkin-checkout-data">{{'entryStatus' | translate}}</div>
              <div class="input-for-selection-checkin-checkout">
                <p-dropdown class="full-width-dropdown" [options]="entryStatusOptions" [(ngModel)]="selectedEntryStatus" optionLabel="label"
                  optionValue="value" placeholder="All" appendTo="body" style="width: 100%"
                  (onChange)="onEntryStatusChange($event)"></p-dropdown>
              </div>
            </div>
          </div>

          <div class="apply-button-filter" >
            <div class="filter-results-text">{{ totalStudents }} {{'resultsAvailable' | translate}}</div>
            <button class="btn-apply" (click)="applyFilter()" [disabled]="applyButtonDisabled()">{{'apply' |
              translate}}</button>
          </div>
        </div>

        <div class="student-count-category-wise-main-container">
          <div class="student-count-category-wise">
            <div *ngIf="isStatsLoading" class="student-count-category-wise-sub-container">
              <div class="first-data-category-wise loader-card" *ngFor="let l of statsLoaderArray">
                <div class="first-data-info-category-wise">
                  <div class="loader-line loader-heading"></div>
                  <div class="loader-line loader-value"></div>
                </div>
              </div>
            </div>

            <div [ngClass]="{
      'student-count-category-wise-sub-container': !isStatsExpanded,
      'student-count-category-wise-sub-container-active': isStatsExpanded
    }" *ngIf="!isStatsLoading">
              <div class="first-data-category-wise" *ngFor="let item of stats || []">
                <div class="first-data-info-category-wise">
                  <div class="heading-container-data-category-wise">
                    {{ item.statKey }}
                  </div>
                  <div class="data-of-row-in-numbers">
                    {{ item.statValue }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="table-of-student">
            <table class="table-data-category-wise">
              <thead class="category-wise-table-header">
                <tr>
                  <ng-container *ngFor="let col of reportColumns">
                    <th *ngIf="col.isDefault === 1">
                      <div class="selected-first-row-category"
                        (click)="expandColumnOption(col.pkReportColumnMapDetailId, $event)">
                        <span>{{ col.columnName }}</span>
                        <span>
                          <img class="row-dropdown-category" src="../../assets/img/row-dropdown.png" alt="arrow" />
                        </span>
                      </div>

                      <div class="option-for-first-row" *ngIf="columnIndex === col.pkReportColumnMapDetailId"
                        (click)="$event.stopPropagation()">
                        <div class="option-for-first-row-data" *ngFor="let innerCol of sortedReportColumns">
                          <span>
                            <input type="checkbox" id="column-name-{{ innerCol.slug }}"
                              [checked]="innerCol.isDefault === 1" [disabled]="innerCol.isDefault === 1"
                              (change)="updateTableColumn(col.slug, innerCol.slug, $event); closeDropdown()" />
                          </span>
                          <label class="slug-labels" for="column-name-{{ innerCol.slug }}">
                            {{ innerCol.columnName }}
                          </label>
                        </div>
                      </div>
                    </th>
                  </ng-container>
                </tr>
              </thead>

              <tbody *ngIf="!isReportLoading" class="category-wise-table-body" (click)="closeDropdown()">
                <ng-container *ngIf="!isReportLoading && reportData && reportData.length > 0; else noDataTpl">
                  <tr *ngFor="let row of reportData">
                    <ng-container *ngFor="let col of reportColumns">
                      <td *ngIf="col.isDefault === 1">
                        {{ row[col.columnName] }}
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>

                <ng-template #noDataTpl>
                  <tr *ngIf="!isReportLoading">
                    <td [attr.colspan]="reportColumns.length" class="no-student-data">
                      {{ 'noData' | translate }}
                    </td>
                  </tr>
                </ng-template>
              </tbody>
              <tbody *ngIf="isReportLoading" class="checkin-checkout-table-body">
                <tr class="loader-data" *ngFor="let _ of rows">
                  <td *ngFor="let _ of cols"><p-skeleton /></td>
                </tr>
              </tbody>
            </table>
            </div>
            
            <div class="pagination-container">
            
              <div class="data-length-selection">
                {{'show' | translate}}
                <select [(ngModel)]="pageLimit" (change)="changePageLimit()">
                  <option *ngFor="let limit of [10,20,30,40,50,60,70]" [value]="limit">
                    {{ limit }}
                  </option>
                </select>
              </div>
            
              <p-paginator [first]="(pageNumber - 1) * pageLimit" [rows]="pageLimit" [totalRecords]="totalRecords"
                (onPageChange)="onPageChange($event)">
              </p-paginator>
            
            </div>
            
            <div class="modal" id="exportReport" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-export-report-pop-up" role="document">
              <div class="modal-content export-report-pop-up-main-container">
                <div class="heading-pop-up-heading">
                  <div class="export-report-heading">
                    <div>{{ 'exportReport' | translate }}</div>
                    <div (click)="closeExportPopUp()" class="close">
                      <i class="ri-close-line"></i>
                    </div>
                  </div>
                  <div class="second-message-container">
                    {{ 'checkincheckoutExport' | translate }}
                  </div>
                </div>
                <div class="body-pop-up-export-report">
                  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                    <div class="send-report-to-another-mail">
                      {{ 'selectColumnsWantExport' | translate}}
                    </div>
                    <div class="export-select-all-toggle">
                      <p-inputSwitch [ngModel]="selectedExportColumns.length === (reportColumns?.length || 0)"
                        (onChange)="toggleSelectAllColumns($event.checked)">
                      </p-inputSwitch>
                    
                      <label class="export-label" >
                        {{ 'selectall' | translate }}
                      </label>
                       </div>
                  </div>
                  <div style="max-height:250px;overflow-y:auto;margin-bottom:12px;">
                    <div class="popup-list-loader" *ngIf="isReportLoading">
                      <p-progressSpinner class="small-spinner">
                      </p-progressSpinner>
                    </div>
                    <div *ngFor="let col of reportColumns; let i = index" class="export-row" [ngClass]="{ 'row-alt': i % 2 === 1 }"
                      [class.disabled]="isReportLoading">
                      <p-inputSwitch class="export-switch" [ngModel]="selectedExportColumns.includes(col.pkReportColumnMapDetailId)"
                        (onChange)="onExportColumnToggle(col.pkReportColumnMapDetailId, $event.checked)">
                        </p-inputSwitch>
                      
                      <label style="margin-left: 10px;">
                        {{ col.columnName }}
                      </label>
                    </div>
                  </div>
                  <div class="export-button" style="display:flex;justify-content:flex-end;gap:8px;">
                    <button (click)="closeExportPopUp()">
                      {{ 'cancel' | translate }}
                    </button>

                    <button  class="export-btn" *ngIf="!isExportingReport" (click)="exportReport()" [disabled]="selectedExportColumns.length === 0">
                      {{ 'export' | translate }}
                    </button>

                    <button *ngIf="isExportingReport">
                      <app-button-loader></app-button-loader>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>